import { createContext, useContext } from "react";
import { useQuery } from "@apollo/client";
import { GET_COIN_CONFIG } from "../../graphql/queries/tip";
import { Box, CircularProgress } from "@mui/material";

export const CoinCfgCtx = createContext(null);

export function TipProvider({ children }) {
  const { data, loading, error } = useQuery(GET_COIN_CONFIG, {
    fetchPolicy: "cache-first",
  });

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={8}>
        <CircularProgress size={48} />
      </Box>
    );
  }
  if (error) return <p>Err …</p>;

  return (
    <CoinCfgCtx.Provider value={data.getCoinConfig}>
      {children}
    </CoinCfgCtx.Provider>
  );
}

export const useCoinConfig = () => {
  const cfg = useContext(CoinCfgCtx);
  if (!cfg) throw new Error("useCoinConfig must be inside <TipProvider>");
  return cfg;
};
